import { Injectable } from '@angular/core';
import { nativeDetectorAvailable } from '@utils/native-detector';

@Injectable({ providedIn: 'root' })
export class CameraDetectorService {
  nativeCameraAvailable = false;

  async detectNativeCamera() {
    this.nativeCameraAvailable = await nativeDetectorAvailable();
  }
}
